var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000023270976686206687520000008772160596364921750_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330.1 413.2",
    style: {
      enableBackground: "new 0 0 330.1 413.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#333333;}\r\n\t.st1{stroke:#000000;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#1A1A1A;stroke-width:5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st3{fill:#292929;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.5,270.6c0,78.5,68.9,142.1,154,142.1s154-63.6,154-142.1S240,161.9,154.9,161.9S0.5,192.2,0.5,270.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.5,258.2c0,19.1,8.3,34.7,18.6,34.7s18.6-15.5,18.6-34.7s-8.3-26.5-18.5-26.5S213.5,239.1,213.5,258.2 L213.5,258.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.9,262.4c0,19.1,8.3,34.7,18.6,34.7s18.6-15.5,18.6-34.7s-8.3-26.5-18.5-26.5S64.9,243.3,64.9,262.4 L64.9,262.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 289.5,
    y1: 2.5,
    x2: 212.5,
    y2: 196.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 289.5,
    y1: 2.5,
    x2: 311.5,
    y2: 57.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 42.7,
    y1: 5.1,
    x2: 119.7,
    y2: 199.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 42.7,
    y1: 5.1,
    x2: 20.7,
    y2: 60.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M292.9,55.5c0,9.6,8.3,17.3,18.6,17.3s18.6-7.7,18.6-17.3s-8.3-13.2-18.5-13.2S292.9,45.9,292.9,55.5 L292.9,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2.1,58c0,9.5,8.3,17.3,18.6,17.3S39.3,67.6,39.3,58S31,44.8,20.8,44.8S2.1,48.5,2.1,58z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnt);
export default __webpack_public_path__ + "static/media/ANT.575e073a2eea6c3ade5a38689653c9cb.svg";
export { ForwardRef as ReactComponent };